import { Injectable, Inject } from '@angular/core';
import { DVMService } from '../services/dvm.service';
import { GeneralHandler } from './general.handler';
import { DVM_CONFIG } from '../digitalvenue.configuration';
import { DVMConfiguration } from '../dvmconfiguration.model';
import { APIConnectionService } from '../services/api-connection.service';
import { FlowControlService } from '../services/flow-control.service';
import { PricingService } from '../services/pricing.service';
import { IsolatedSeatsApiService } from '../services/isolated-seats-api.service';

@Injectable()
export class LoadSeatselectionHandler extends GeneralHandler {
    constructor(@Inject(DVM_CONFIG) private dvmConfig: DVMConfiguration,
                private pricing: PricingService,
                private flowControl: FlowControlService,
                private connection: APIConnectionService,
                protected dvmService: DVMService,
                private isolatedSeats: IsolatedSeatsApiService) {
        super('end_load', dvmService);
    }

    loadBlockmapHandler(viewer) {
        viewer.setAvailability([]);
        this.flowControl.showLoader(true);
        this.connection.getPlanAvailability(this.flowControl.currentPlan, this.flowControl.upgradePlan).subscribe(
            planAvailability => {
              this.flowControl.availabilty.next(planAvailability);
                // tslint:disable-next-line: forin
                for (const areaId in planAvailability) {
                    this.pricing.areapricing[areaId] = {
                        min: planAvailability[areaId]['min_price'] ? planAvailability[areaId]['min_price'].toFixed(2) : 0,
                        max: planAvailability[areaId]['max_price'] ? planAvailability[areaId]['max_price'].toFixed(2) : 0
                    };
                }
                //Guardamos availabilty en Flow Control
                this.flowControl.latestAreaAvailability = Object.keys(planAvailability);
                //Seteamos Availabilty según Flex Mode
                this.flowControl.flexMode ?
                viewer.setAvailable('section',this.mergeAllSections(planAvailability)) : //Nueva
                viewer.setAvailable('section', Object.keys(planAvailability));           //Original

                // viewer.setAvailable('section', Object.keys(this.flowControl.suitesHash));
                // viewer.setNodesTag(Object.keys(this.flowControl.suitesHash), 'vip');
                // viewer.setNodesTag(Object.keys(this.flowControl.greenSuites), 'vipGreen');
                if (!this.flowControl.upgradePlan) {
                    this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                        basket => {
                            const basketArray = [];
                            for (const seat of basket) {
                                basketArray.push('S_' + seat['section']);
                            }
                            viewer.setNodesTag(basketArray, 'owned');
                        },
                        error => {
                            console.error(error.message);
                        }
                    );
                }
                this.flowControl.showLoader(false);
            },
            error => {
                console.error(error);
                this.flowControl.showLoader(false);
            });

    }

    loadSeatmapHandler(viewer) {
        viewer.setAvailability([]);
        this.flowControl.showLoader(true);
        if(!this.flowControl.flexMode){
            this.connection.getPlanSectionAvailability(this.flowControl.currentPlan,
            viewer.getMapId(), this.flowControl.upgradePlan).subscribe(
            planSectionAvailability => {
                // gets the pending and discarded seats
                const pendingSeats = this.isolatedSeats.getPendingSeats();
                const discardedSeats = this.isolatedSeats.getDiscardedSeats();
                if (discardedSeats) {
                    Object.values(discardedSeats).forEach((seat => {
                        this.pricing.seatpricing[seat['id']] = {price: seat['price'],
                        price_type: seat['price_type_name']};
                    }));
                }

                // tslint:disable-next-line: forin

                for (const seatId in planSectionAvailability) {
                    this.pricing.seatpricing[seatId] = {price: planSectionAvailability[seatId].price_type.prices[0].price,
                    price_type: planSectionAvailability[seatId].price_type.name,
                      // twins needs to handle two buyer types https://mmcbcn.atlassian.net/browse/IT-2685
                      all_prices: planSectionAvailability[seatId].price_type.prices};
                }
                viewer.setAvailable('seat', Object.keys(planSectionAvailability));
                if (!this.flowControl.upgradePlan) {
                    this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                        basket => {
                            const basketArray = [];
                            for (const seat of basket) {
                                // Comentado para permitir que las sillas owned aparezcan marcadas en el segundo step.
                                // De lo contrario, solamente aparecerán las kept y sólo cuando haya discarded.

                                // if (discardedSeat != null) {
                                    // if (Object.keys(discardedSeat).length >= 0 && !discardedSeat[seat['id']]){
                                        basketArray.push(seat['id']);
                                    // }
                                // }
                            }
                            viewer.setNodesTag(basketArray, 'owned');
                            if (discardedSeats && discardedSeats.length) {
                                viewer.setNodesTag(Object.keys(discardedSeats), null);
                                viewer.setAvailable('seat', Object.keys(discardedSeats));
                                discardedSeats.forEach(element => {
                                    viewer.setNodesTag(element.id, 'owned');
                                });
                            }
                            this.isolatedSeats.printIsolatedSeats(pendingSeats);
                        },
                        error => {
                            console.error(error.message);
                        }
                    );
                }
                for (const selectedSeat of Object.values(this.flowControl.Basket)) {
                    viewer.select(selectedSeat.id);
                }
                this.flowControl.showLoader(false);
            },
            error => {
                console.error(error);
                this.flowControl.showLoader(false);
            }
        );
        }


    }

    protected handle(error, viewer) {
        if (error) { console.error(error); }
        viewer = viewer.instance;
        if (viewer.getMapId() === this.dvmConfig.map_id) {
            this.loadBlockmapHandler(viewer);
        } else {
            this.loadSeatmapHandler(viewer);
        }
    }

     //PARA TESTEO CON API CHELSEA
     private mergeAllSections(sections){
        //@ts-ignore
       return Object.values(sections).reduce((acc,val)=>(val.sections.forEach(s => acc.push(s.toString())),acc),[]);
    }
}
